import { useEffect, useRef } from "react";

import { containTabKey } from "../lib/wizard";

function PresentationConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  danger = false,
  busy = false,
  errorMessage,
  children,
  dialogClassName,
  onCancel,
  onConfirm,
}) {
  const confirmRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    confirmRef.current?.focus();
    const onKey = (event) => {
      if (event.key === "Tab") {
        containTabKey(event, dialogRef.current);
        return;
      }
      if (event.key === "Escape" && !busy) onCancel?.();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, busy, onCancel]);

  if (!open) return null;

  const dialogClass = [
    "presentation-modal__dialog",
    "presentation-modal__dialog--sm",
    dialogClassName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      ref={dialogRef}
      className="presentation-modal presentation-modal--nested"
      role="dialog" aria-modal="true" aria-labelledby="presentation-confirm-title">
      <div className="presentation-modal__backdrop" onClick={busy ? undefined : onCancel} />
      <div className={dialogClass}>
        <header className="presentation-modal__head">
          <h2 id="presentation-confirm-title">{title}</h2>
        </header>
        <div className="presentation-modal__body">
          <p>{message}</p>
          {children}
          {errorMessage ? (
            <p className="presentation-form__error" role="alert">
              {errorMessage}
            </p>
          ) : null}
        </div>
        <footer className="presentation-modal__foot">
          <button type="button" className="action-btn" onClick={onCancel} disabled={busy}>
            Скасувати
          </button>
          <button
            ref={confirmRef}
            type="button"
            className={danger ? "action-btn action-btn--danger" : "action-btn"}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "Зачекайте…" : confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
}

export default PresentationConfirmDialog;
